import { h, defineComponent, SetupContext } from 'vue';
// @ts-ignore
import { BUpload } from 'buefy/dist/esm/upload';
import { ValidationError } from '@/entities/validation';
import { SetterCallback } from '@/ui/types';
import { Field, FieldProps } from './Field';
import { isKeyEnter } from '@/ui/helpers';
import { t } from '@/ui/i18n/i18n';

export interface UploadFieldProps {
  type?: string;
  accept?: string;
  name: string;
  label: string;
  buttonLabel?: string;
  value: File | null | string | unknown;
  dragDrop?: boolean;
  native?: boolean;
  multiple?: boolean;
  loading?: boolean;
  required: boolean;
  expanded?: boolean;
  rounded?: boolean;
  disabled?: boolean;
  horizontal?: boolean;
  errors?: ValidationError[];
  hideLabel?: boolean;
  classes?: string;
  tooltipText?: string;
}

export const UploadField = defineComponent<UploadFieldProps>({
  name: 'UploadField',
  props: [
    'type', 'accept', 'name', 'label', 'value', 'dragDrop',
    'native', 'multiple', 'loading', 'expanded', 'rounded',
    'required', 'errors', 'disabled', 'horizontal',
    'hideLabel', 'classes', 'tooltipText', 'buttonLabel',
  ],
  setup(props, context: SetupContext) {
    return function render() {
      const fieldProps: FieldProps = {
        label: props.label,
        name: props.name,
        required: props.required,
        errors: props.errors ?? [],
        hideLabel: props.hideLabel,
        horizontal: props.horizontal,
        disabled: props.disabled,
        tooltipText: props.tooltipText,
      };

      return h(Field, { props: fieldProps }, [
        h(BUpload, {
          props: {
            value: props.value instanceof File ? props.value : null,
            name: props.name,
            type: props.type,
            accept: props.accept,
            disabled: props.disabled,
            dragDrop: props.dragDrop,
            rounded: props.rounded,
            expanded: props.expanded,
            loading: props.loading,
            multiple: props.multiple,
            native: props.native,
          },
          class: props.classes ?? '',
          attrs: {
            ...context.attrs,
          },
          on: {
            input: (newValue: string) => {
              context.emit('input', newValue);
            },
            ...context.listeners,
          },
          nativeOn: {
            keyup: (e: KeyboardEvent) => {
              if (isKeyEnter(e)) {
                context.emit('input:enter');
              }
            },
          },
        }, [
          h('span', { attrs: { class: `button ${props.type}` } }, [props.buttonLabel || t('common.upload')]),
          props.value
            ? h('span', { attrs: { class: 'file-name' } }, [props.value instanceof File ? props.value.name : ''])
            : null,
        ]),
      ]);
    };
  },
});

export function uploadField(props: UploadFieldProps, input: SetterCallback<string>, on: Record<string, Function> = {}) {
  return h(UploadField, {
    props,
    on: { input, ...on },
  });
}
